module.exports = __webpack_public_path__ + "fonts/Inter-800-greek-ext55.2329210.woff2";